import { getRecyclerContents } from "routes/schedule/plugins/recycle-bin/controller/recycle-bin-controller"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { useMemo, useState } from "react"
import { Grid, List, Typography } from "@mui/material"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { BinItem } from "routes/schedule/plugins/recycle-bin/components/bin-item"
import { NoResults } from "lib/@components/no-results/no-results"
import { RecycleType } from "event-definitions"
import { Repeat } from "lib/@components/repeat"
import { SearchBoxUsingSearchParam } from "lib/@components/searchBoxUsingSearchParam"
import { Summary } from "routes/schedule/plugins/recycle-bin/components/summary"
import LoadingScreen from "minimals-template/components/LoadingScreen"

export function BinItems() {
    const [filter, setFilter] = useState("")
    let { loading, data: items } = getRecyclerContents.useResults.status()
    items = items ?? []
    items.forEach((item) => {
        item.viewType = RecycleType.call({ item, type: null })
        item.date = new Date(item.date)
    })

    const groups = items.groupBy("viewType")
    delete groups.null

    const [search] = useSearchParam("search")
    const list = useMemo(
        () =>
            (items ?? []).filter((i) => !search?.trim() || i.name?.toLowerCase().includes(search.trim().toLowerCase())),
        [search, JSON.stringify(items)]
    )
    if (!list.length && !!loading) return <LoadingScreen />
    return (
        <>
            <Grid container my={1} spacing={1} sx={{ m: "auto", maxWidth: 800 }}>
                {!!Object.keys(groups).length && (
                    <Grid item xs={12}>
                        <Typography variant="overline" color="text.secondary">
                            Item Types
                        </Typography>
                    </Grid>
                )}
                <Repeat
                    list={Object.entries(groups)}
                    item={<Summary total={items.length} setFilter={updateFilter} current={filter} />}
                />
            </Grid>
            <SearchBoxUsingSearchParam placeholder="Search by name..." />

            <List data-cy="recyle-bin-list">
                {!!list.length && (
                    <PagedRepeat
                        pageSize={10}
                        list={list.filter(({ viewType }) => !filter || viewType === filter)}
                        bind
                        item={<BinItem />}
                        showTop
                    />
                )}
                {!list.length && <NoResults />}
            </List>
        </>
    )

    function updateFilter(filter) {
        setFilter((current) => {
            if (current === filter) {
                return ""
            }
            return filter
        })
    }
}
